<template>
  <div class="sign-up-basics">
    <header>
    <div class="grid-container header">
      <img class="logo" src="../../assets/images/global/logo.svg">
      <router-link class="btn bg-one active" to="login">Log In</router-link>
    </div>
    </header>
    <section class="instructions">
      <div class="grid-container">
        <div class="col-4">
          <h2>Tell us a bit more about you, your work and areas of interest.</h2>
        </div>
      </div>
    </section>
    <section class="long-form">
      <div class="grid-container">
        <div class="row">
          <div class="shift-3 col-3">
            <label>First name:</label>
            <input class="" type="text" v-model.trim="$parent.firstname" placeholder="eg. John" required />
          </div>
          <div class="col-3">
            <label>Last name:</label>
            <input class="" type="text" v-model.trim="$parent.surname" placeholder="eg. Smith" required />
          </div>
        </div>
        <div class="row">
          <div class="shift-3 col-3">
            <label>Where do you work?</label>
            <input class="" type="text" v-model.trim="$parent.organisation" placeholder="eg. Example PLC" required />
          </div>
          <div class="col-3">
            <label>Sector:</label>
            <select v-model="$parent.sector">
              <option disabled value="">Please select one</option>
              <option>NGO</option>
              <option>Students</option>
              <option>Academia</option>
              <option>Researchers</option>
              <option>Private Sector</option>
              <option>Government</option>
              <option>Development Workers</option>
            </select>
          </div>
          <!-- <div class="col-3">
            <label>Organisation website:</label>
            <input class="" type="url" v-model.trim="$parent.website" placeholder="example.com" required />
          </div> -->

        </div>
        <div class="row">
          <div class="shift-3 col-3">
            <label>Where are you currently based?</label>
            <input type="text" v-model.trim="$parent.location" placeholder="eg. London"></input>
<!--             <ul class="input-options active">
              <li class="input-option">
                London, United Kingdom
              </li>
            </ul> -->
          </div>
          <div class="col-3">
            <label>What's your job title?</label>
            <input class="" type="text" v-model.trim="$parent.jobtitle" placeholder="eg. Operations Manager" required />
          </div>
        </div>
      </div>
    </section>
    <section class="sign-up-navigation">
    <div class="grid-container">
      <a v-on:click.stop.prevent="stepBack" class="link-back">Change Password</a>
      <a id="next" v-on:click.stop.prevent="register" class="btn btn-big bg-four register" :class="{ active: formComplete }">Next</a>
    </div>
    </section>
  </div>
</template>

<script>
import { auth, db } from '@/firebase'
import toTitleCase from 'titlecase'

export default {
  name: 'Register',
  data () {
    return {
      now: Date.now()
    }
  },
  methods: {
    stepBack () {
      this.$parent.currentStep--
    },
    register () {
      if (this.formComplete) {
        let parent = this
        let user = auth.currentUser

        // Generate a slug and search term
        let slug = this.$parent.firstname + '-' + this.$parent.surname
        let saveSlug = slug.toLowerCase()

        let searchterm = this.$parent.firstname + ' ' + this.$parent.surname
        let saveSearchTerm = searchterm.toLowerCase()

        db.ref('users-registration/' + user.uid).update({
          firstname: toTitleCase(this.$parent.firstname),
          surname: toTitleCase(this.$parent.surname),
          organisation: toTitleCase(this.$parent.organisation),
          sector: this.$parent.sector,
          jobtitle: toTitleCase(this.$parent.jobtitle),
          location: toTitleCase(this.$parent.location),
          joined: this.now,
          slug: saveSlug,
          searchterm: saveSearchTerm,
          email: this.$root.user.email
        }, function () {
          // On complete
          parent.$parent.currentStep++
        })
      }
    }
  },
  computed: {
    formComplete: function () {
      let p = this.$parent
      if (p.firstname && p.surname && p.organisation && p.location && p.jobtitle) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register-Step-3.vue?4803bfd0